import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ConversationContact as ConvContact, ConversationContact, Contact, Conversation } from 'app/clmtlk/shared/model/conversationContacts';
import * as ServerObj from 'app/clmtlk/shared/model/serverObjects';
import { Router, ActivatedRoute } from '@angular/router';
import { Action } from 'app/clmtlk/shared/model/action';
import { SessionStorageService } from 'ngx-webstorage';
import { WindowRefService } from '../../common/service/window-ref.service';
import { environment } from '../../../environments/environment';
import { GoogleAnalyticsService } from 'app/common/service/google-analytics.service';
import { Subscription, Observable, Subject, ConnectableObservable } from 'rxjs/Rx';
import { ClmtlkService } from 'app/clmtlk/shared/service/clmtlk.service';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { InboxResolver } from 'app/clmtlk/inbox/shared/inbox-resolver.service';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
//import * as moment from 'moment';



@Component({
  selector: 'clmtlk-inbox',
  templateUrl: './inbox.component.html',
  styleUrls: ['./inbox.component.scss']
})
export class InboxComponent implements OnInit, OnDestroy {

  @ViewChild('messageGrid') messageGrid: any;

  response: ServerObj.Response;
  convContacts: ConvContact[];
  private window: Window;
  busy: Subscription;
  loggedinUser: ConvContact;
  deletedConversations:Conversation;


  constructor(private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private sessionService: SessionStorageService,
    private clmtlkService: ClmtlkService,
    private clmtlkSessionService: ClmtlkSessionService,
    private inboxResolver: InboxResolver,
    private windowService: WindowRefService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private toastrService: ToastrService,
    private datePipe: DatePipe) {
    this.window = windowService.nativeWindow;

  }

  ngOnInit() {

    this.loggedinUser = this.clmtlkSessionService.loggedInContact;
    // Full Story Identify setup
    if (environment.envName === 'prod') {
      window['clmtlkFullStory'].identify('clmtlk-' + this.clmtlkSessionService.authToken, {
        displayName: 'clmtlk-' + this.clmtlkSessionService.loggedInContact.contacts.contact[0].CTC_NM
      });
    }

    // Google Analytics
    this.googleAnalyticsService.trackPage('/inbox?a=' + this.clmtlkSessionService.authToken);

    //console.info("inboxResolver");
    this.route.data.subscribe(
      (data: { convContacts: ConvContact[]}) => {
        this.convContacts = this.populateFormatedData(data.convContacts);

      }
    );
  }


//   sortByReceivedDate(event) {
//     const comparer = function (a, b): number {
//       let formatedA = moment(a.date, "DD.MM.YYYY").format('YYYY-MM-DD');
//       let formatedB = moment(b.date, "DD.MM.YYYY").format('YYYY-MM-DD');
//       let result: number = -1;

//       if (moment(formatedB).isBefore(formatedA, 'day')) result = 1;
//       return result * event.order;
//     };

//     this.convContacts.sort(comparer);
// }



  markAllAsRead(content) {
    const modalOptions: any = { backdrop: 'static', keyboard: false };
    this.modalService.open(content, modalOptions).result.then((result) => {
      this.messageGrid.markAllAsRead();
    }, (reason) => {

    });
  }

  refresh() {
    this.inboxResolver.refreshInbox().subscribe(
      (convContacts: ConvContact[]) => {
        this.convContacts = this.populateFormatedData(convContacts);
      });
  }

  newConversation() {

    if (this.convContacts.length > 0) {
      this.clmtlkSessionService.setConversationContext('NEW_CUSTOMER_CONVERSATION', null, Action.NEWCONVERSATION);
    } else {
      this.clmtlkSessionService.setConversationContext('NEW_STREAM_CONVERSATION',
                    this.clmtlkSessionService.reuseConv, Action.NEWCONVERSATION);
    }
    this.router.navigate(['/message', 'new']);
  }

  populateFormatedData(convContacts: ConvContact[]): ConvContact[] {
    convContacts.forEach(convContact => {
        convContact.formatedReceivedDate =
            this.datePipe.transform(convContact.messages.message[0].INSERT_TMSTMP.toLocaleString() + 'Z', 'medium');
        convContact.formatedFrom = convContact.contacts.contact[0].CTC_NM +
                                      (convContact.CTC_IMPRS_NM ?
                                      `(${convContact.CTC_IMPRS_NM})` : '');
        let formatedTo = ''; let formatedCc = '';
        const messageContacts: ConversationContact[] = convContact.messages.message[0].conversationContacts.conversationContact;
        messageContacts.forEach(conversationContact => {
            if (conversationContact.CTC_ADDR_TYP_CD === 'to') {
              formatedTo = this.getContactAddress(formatedTo, conversationContact);
            } else if (conversationContact.CTC_ADDR_TYP_CD === 'cc') {
              formatedCc = this.getContactAddress(formatedTo, conversationContact);
            }
        });
        convContact.formatedTo = formatedTo;
        convContact.formatedCc = formatedCc;
    });
    return convContacts;
  }

  getContactAddress(formatedAddress: string, conversationContact: ConversationContact): string {
    const isStreamUser: boolean = this.loggedinUser.CTC_SRC_CD === 'st';
    const contact:Contact = conversationContact.contacts.contact[0];
    let contactDisplay: string = contact.CTC_NM + (conversationContact.CTC_IMPRS_NM ?
                                    `( ${conversationContact.CTC_IMPRS_NM} )` : '');
    // if (isStreamUser) {
    // contactDisplay = `${contactDisplay}( ${conversationContact.contacts.contact[0].CTC_VAL_TXT} )`;
    // }

    if(this.loggedinUser.CTC_ID == contact.CTC_ID) {
      contactDisplay = `<mark>${contactDisplay}</mark>`;
    }
    formatedAddress = (formatedAddress === '') ? contactDisplay : formatedAddress + ', ' + contactDisplay;
    return formatedAddress;
  }



  ngOnDestroy(): void {
    this.toastrService.clear();
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/inbox/inbox.component.ts